import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COUNTIES_ACTION_TYPE } from '../actions';

const initialState = [];

const countiesReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case COUNTIES_ACTION_TYPE.GET_COUNTIES:
        return payload;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default countiesReducer;
